import { Suspense, lazy, useMemo } from "react";

import { toast } from "react-toastify";

import type { ToastModelConfig } from "shared/types/ToastModelConfig";

import useResize from "./useResize";

const ToastNotification = lazy(() => import("shared/Components/ToastNotification"));

const useToast = () => {
	const { isMobile } = useResize();

	return useMemo(
		() => ({
			showToast: async ({
				type,
				icon,
				position = isMobile ? "bottom-center" : "bottom-right",
				autoCloseMs = 10000,
				...rest
			}: ToastModelConfig) => {
				toast(
					({ closeToast }) => (
						<Suspense>
							<ToastNotification type={type} icon={icon} onClose={closeToast} {...rest} />
						</Suspense>
					),
					{
						position: position,
						...rest,
						autoClose: autoCloseMs,
						hideProgressBar: true,
						closeOnClick: false,
						rtl: false,
						pauseOnFocusLoss: true,
						draggable: false,
						pauseOnHover: false
					}
				);
			},
			clearAllToasts: () => {
				toast.dismiss();
			}
		}),
		[isMobile]
	);
};

export default useToast;
